import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteTransferBatchesMutationVariables = Types.Exact<{
  transferBatchIds: Array<Types.Scalars['ID']['input']>;
}>;


export type DeleteTransferBatchesMutation = { __typename?: 'Mutation', deleteTransferBatches: { __typename?: 'DeleteTransferBatchesPayload', successful: boolean, result?: Array<{ __typename?: 'TransferBatch', id: string }> | null } };


export const DeleteTransferBatches = /*#__PURE__*/ gql`
    mutation DeleteTransferBatches($transferBatchIds: [ID!]!) {
  deleteTransferBatches(input: {transferBatchIds: $transferBatchIds}) {
    result {
      id
    }
    successful
  }
}
    ` as unknown as DocumentNode<DeleteTransferBatchesMutation, DeleteTransferBatchesMutationVariables>;

          

          export const useDeleteTransferBatchesMutation = (options?:MutationHookOptions<DeleteTransferBatchesMutation, DeleteTransferBatchesMutationVariables>) => useMutation(DeleteTransferBatches, options);
          

          export type DeleteTransferBatchesMutationOptions = MutationHookOptions<DeleteTransferBatchesMutation, DeleteTransferBatchesMutationVariables>;

          

          export type DeleteTransferBatchesMutationResult = ReturnType<typeof useDeleteTransferBatchesMutation>[1];

          
